import { ListChecks } from "lucide-react";

/**
 * Top tab-nav bar shown at the top of each Strategy parent shell.
 * Shows 3 topic tabs + 1 To Do tab. Selecting a tab updates the URL `?tab=`.
 *
 * Props:
 *   tabs        — [{ key, label }] the 3 sub-topic tabs (no "todos" here — added implicitly)
 *   activeTab   — current tab key
 *   onSelect    — (tabKey) => void
 *   todoCount   — number of open (not-done) to-dos across the 3 sub-topics
 */
export default function StrategyTabBar({ tabs, activeTab, onSelect, todoCount = 0 }) {
  const all = [...tabs, { key: "todos", label: "To Do", isTodo: true }];
  return (
    <div className="flex flex-wrap gap-1 border-b border-slate-200 mb-6" data-testid="strategy-tab-bar">
      {all.map((t) => {
        const isActive = activeTab === t.key;
        return (
          <button
            key={t.key}
            type="button"
            onClick={() => onSelect(t.key)}
            data-testid={`strategy-tab-${t.key}`}
            className={`px-4 py-2.5 text-sm font-medium border-b-2 -mb-px transition-colors flex items-center gap-2 ${
              isActive
                ? "border-teal-500 text-teal-700"
                : "border-transparent text-slate-500 hover:text-slate-800 hover:border-slate-300"
            }`}
          >
            {t.isTodo && <ListChecks className="w-4 h-4" />}
            <span>{t.label}</span>
            {t.isTodo && todoCount > 0 && (
              <span
                className={`inline-flex items-center justify-center min-w-[20px] h-5 rounded-full text-[10px] font-semibold px-1.5 ${
                  isActive ? "bg-teal-100 text-teal-700" : "bg-slate-200 text-slate-600"
                }`}
                data-testid="strategy-tab-todo-count"
              >
                {todoCount}
              </span>
            )}
          </button>
        );
      })}
    </div>
  );
}
